import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex py-2 align-center justify-center text-subtitle-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn_reset = _resolveComponent("v-btn-reset")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_RuleTable = _resolveComponent("RuleTable")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_tabs, {
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
        style: {"border-radius":"16px","overflow":"hidden"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, {
            value: "CompanyScopes",
            href: "#CompanyScopes"
          }, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [
              _createTextVNode("Perimètres")
            ])),
            _: 1
          }),
          _createVNode(_component_v_tab, {
            value: "DuplicatesAndOrphans",
            href: "#DuplicatesAndOrphans"
          }, {
            default: _withCtx(() => _cache[18] || (_cache[18] = [
              _createTextVNode("Doublons & Orphelins")
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_tabs_window, {
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.activeTab) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: "CompanyScopes" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        cols: "12",
                        class: "my-3 justify-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn_primary, {
                                block: "",
                                height: "40px",
                                elevation: "0",
                                class: "rounded-lg gradient",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.routeEdition())),
                                "data-cy": "WordingAnalysisTable-add"
                              }, {
                                default: _withCtx(() => _cache[19] || (_cache[19] = [
                                  _createTextVNode(" Ajouter ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "10",
                            class: "pl-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.search,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.search) = $event)),
                                label: "Recherche",
                                clearable: "",
                                "onClick:clear": _cache[9] || (_cache[9] = ($event: any) => (_ctx.search = '')),
                                "hide-details": "",
                                density: "compact"
                              }, {
                                "append-inner": _withCtx(() => [
                                  _createVNode(_component_v_menu, {
                                    modelValue: _ctx.menu,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.menu) = $event)),
                                    "close-on-content-click": false,
                                    "offset-y": "",
                                    left: "",
                                    bottom: "",
                                    elevation: "1"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createVNode(_component_v_btn_icon, _mergeProps({
                                        elevation: "0",
                                        icon: "$tune",
                                        size: "small",
                                        style: {"margin-top":"-2px"}
                                      }, props, { "data-cy": "ossFilterBar-dialog" }), null, 16)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card, {
                                        class: _normalizeClass({
                                                    'pa-3 pb-0': true,
                                                    'mt-3': _ctx.$vuetify.display.mobile,
                                                }),
                                        elevation: "1",
                                        style: _normalizeStyle({
                                                    width: !_ctx.$vuetify.display.mobile
                                                        ? '700px'
                                                        : undefined,
                                                })
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { cols: "12" }, {
                                                default: _withCtx(() => _cache[20] || (_cache[20] = [
                                                  _createElementVNode("h3", null, "Filtres", -1)
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_row, {
                                            "no-gutters": "",
                                            class: "py-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                                                class: _normalizeClass(
                                                            _ctx.$vuetify.display.mobile
                                                                ? 'pa-1'
                                                                : 'px-1'
                                                        ),
                                                "data-cy": "scopeFilterBar-client"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_text_field_filled, {
                                                    modelValue: _ctx.clientSearch,
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.clientSearch) = $event)),
                                                    label: "Filtrer par client",
                                                    "hide-details": true
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              }, 8, ["cols", "class"]),
                                              _createVNode(_component_v_col, {
                                                cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                                                class: _normalizeClass(
                                                            _ctx.$vuetify.display.mobile
                                                                ? 'pa-1'
                                                                : 'px-1'
                                                        ),
                                                "data-cy": "scopeFilterBar-activity"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_text_field_filled, {
                                                    modelValue: _ctx.activitySearch,
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activitySearch) = $event)),
                                                    label: "Filtrer par activité",
                                                    "hide-details": true
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              }, 8, ["cols", "class"]),
                                              _createVNode(_component_v_col, {
                                                cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                                                class: _normalizeClass(
                                                            _ctx.$vuetify.display.mobile
                                                                ? 'pa-1'
                                                                : 'px-1'
                                                        ),
                                                "data-cy": "scopeFilterBar-taxSystem"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_select_filled, {
                                                    modelValue: _ctx.taxSystemSearch,
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.taxSystemSearch) = $event)),
                                                    label: "Filtrer par régime",
                                                    items: _ctx.taxSystemList,
                                                    "hide-details": true
                                                  }, null, 8, ["modelValue", "items"])
                                                ]),
                                                _: 1
                                              }, 8, ["cols", "class"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_divider),
                                          _createVNode(_component_v_card_actions, { class: "d-flex justify-space-between" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_btn_reset, {
                                                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.clearAllFilters()), ["stop"])),
                                                "data-cy": "scopeFilterBar-resetFilter",
                                                size: "small"
                                              }),
                                              _createVNode(_component_v_btn, {
                                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.menu = false)),
                                                "data-cy": "scopeFilterBar-validate",
                                                size: "small",
                                                variant: "tonal"
                                              }, {
                                                default: _withCtx(() => _cache[21] || (_cache[21] = [
                                                  _createTextVNode(" Valider ")
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["class", "style"])
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_RuleTable, {
                    rule: 'companyScope',
                    items: _ctx.formattedScopes,
                    allTargets: true,
                    hideDeletion: true,
                    hideDuplication: true,
                    accountingCompanyId: _ctx.accountingCompanyId,
                    patternCount: _ctx.patternCount,
                    firstRequestDone: _ctx.firstRequestDone,
                    pagination: _ctx.pagination,
                    onToRoute: _cache[10] || (_cache[10] = ($event: any) => (_ctx.routeEdition($event.id))),
                    maxHeight: _ctx.maxHeightRT
                  }, null, 8, ["items", "accountingCompanyId", "patternCount", "firstRequestDone", "pagination", "maxHeight"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: "DuplicatesAndOrphans" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                cols: "12",
                class: "pt-1 justify-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.orphans,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.orphans) = $event)),
                    inline: "",
                    class: "d-flex justify-center",
                    color: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_radio, {
                        label: "Doublons",
                        value: false,
                        class: "d-flex align-center"
                      }),
                      _createVNode(_component_v_radio, {
                        label: "Orphelins",
                        value: true,
                        class: "d-flex align-center"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_ctx.loadingDuplicate)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    "no-gutters": "",
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "8" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            class: "default_card",
                            elevation: "0",
                            "pa-0": "",
                            style: {"margin":"5px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { class: "d-flex align-center" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "2" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_skeleton_loader, { type: "avatar" })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "9" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_skeleton_loader, {
                                        type: "heading",
                                        class: "my-3"
                                      }),
                                      _createVNode(_component_v_skeleton_loader, {
                                        type: "text",
                                        class: "my-auto"
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_RuleTable, {
                ref: "ruleComponent",
                rule: 'companyScope',
                getTitle: _ctx.getTitle,
                items: _ctx.filteredScopeList,
                allTargets: true,
                hideStatus: true,
                hideTargets: _ctx.orphans,
                hideEdition: true,
                hideDeletion: true,
                hideDuplication: true,
                hideIntersection: true,
                onToRoute: _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectDuplicates($event)))
              }, null, 8, ["getTitle", "items", "hideTargets"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.childrenDialog,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.childrenDialog) = $event)),
        title: "Doublons",
        "valid-title": _ctx.orphans ? 'Supprimer' : 'Fusionner',
        error: true,
        validDisabled: _ctx.disableChildrenValid,
        onClose: ($event: any) => (true),
        onValid: _cache[16] || (_cache[16] = ($event: any) => (_ctx.scopesMerge())),
        validLoading: _ctx.childrenValidLoading,
        width: "800px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTargets(_ctx.selectedChildrenList[0]), (value, key) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: value + key
                    }, [
                      value
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createVNode(_component_v_icon, {
                              size: "x-small",
                              class: "mr-2",
                              icon: _ctx.iconMapping[key],
                              color: "secondary"
                            }, null, 8, ["icon"]),
                            _createTextVNode(" " + _toDisplayString(value), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider)
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_oss_data_table, {
                headers: _ctx.childrenHeaders,
                items: _ctx.selectedChildrenList,
                "fixed-header": true,
                "table-hover": true,
                striped: true,
                dense: true,
                "virtual-scroll": true,
                displayRowNumber: true,
                showSelect: true,
                checkboxDisplayCondition: _ctx.isCheckable,
                modelValue: _ctx.toMergeOrDeleteScopes,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.toMergeOrDeleteScopes) = $event)),
                "checkbox-color": "primary",
                class: "table elevation-0",
                height: "60vh"
              }, {
                "item.checkbox": _withCtx(({ isSelected, onSelect }) => [
                  _createVNode(_component_v_checkbox, {
                    class: "pa-0 my-0 ml-3",
                    ripple: false,
                    color: "primary",
                    "model-value": isSelected,
                    onClick: _withModifiers(onSelect, ["stop"]),
                    density: "compact",
                    "hide-details": ""
                  }, null, 8, ["model-value", "onClick"])
                ]),
                "item.view": _withCtx(({ item }) => [
                  (item._count > 0)
                    ? (_openBlock(), _createBlock(_component_v_menu, {
                        location: "end",
                        "open-on-hover": true,
                        "open-on-click": false,
                        key: 'menu' + item.key
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$oss-eye" }, props), null, 16)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, {
                            items: _ctx.getItems(item)
                          }, null, 8, ["items"])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["headers", "items", "checkboxDisplayCondition", "modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "valid-title", "validDisabled", "validLoading"])
    ]),
    _: 1
  }))
}